<template>
  <span class="dot-text"><slot /></span>
</template>

<script>
export default {
  name: "DotText"
};
</script>

<style lang="scss" scoped>
.dot-text {
  display: inline-flex;
  align-items: center;
  &::before {
    content: "";
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    background: #ccc;
    margin-right: 10px;
    border-radius: 50%;
  }

  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;

  color: #6d7179;

  &._warning::before {
    background: #f6931d;
  }

  &._error::before {
    background: #ff0000;
  }

  &._success {
    &::before {
      background: #005197;
    }
    font-weight: 500;
    color: #005197;
  }
  &._no-text {
    &::before {
      margin-right: 0;
    }
  }
}
</style>
